"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PunchCardsModule = /** @class */ (function () {
    function PunchCardsModule() {
    }
    return PunchCardsModule;
}());
exports.PunchCardsModule = PunchCardsModule;
